import { axiosInstance } from '@/lib/axios';
import { DriversResponse, PaginatedDriversResponse } from './types';

type Props = {
  companyId: string
  page?: number
  pageSize?: number
  groupId?: number
  isActive?: boolean
  search?: string
}

export function getDrivers ({ companyId, page, pageSize, groupId, isActive, search }: Props) {
  const params = new URLSearchParams();
  
  if (page !== undefined) params.append('page', page.toString());
  if (pageSize !== undefined) params.append('pageSize', pageSize.toString());
  if (groupId !== undefined) params.append('groupId', groupId.toString());
  if (isActive !== undefined) params.append('isActive', isActive.toString());
  if (search !== undefined && search.trim() !== '') params.append('search', search.trim());
  
  const queryString = params.toString();
  const url = `/api/${companyId}/drivers${queryString ? `?${queryString}` : ''}`;
  
  // Return paginated response if pagination params are provided
  if (page !== undefined || pageSize !== undefined) {
    return axiosInstance.get<PaginatedDriversResponse>(url);
  }
  
  return axiosInstance.get<DriversResponse>(url);
}
